export enum ShortcutDisbursementProducts {
  BULK_DISBURSEMENT = 'BULK_DISBURSEMENT',
  API_DISBURSE = 'API_DISBURSE',
  CLAIM_FUND = 'CLAIM_FUND',
  INTERNATIONAL_TRANSFER = 'INTERNATIONAL_TRANSFER',
}

export type ShortcutMenu = {
  title: string;
  description: string;
  iconName: string;
  isFeatureIcon: boolean;
  onClick: () => void;
  showVisibility: ShortcutDisbursementProducts[];
  havePermission?: boolean;
};

export type ShortcutSideModalProps = {
  show: boolean;
  showVendorMaintenance: boolean;
  productName: ShortcutDisbursementProducts;
  onClose: () => void;
  handleToggleSideModal: () => void;
  handleAutoReportModal: () => void;
  handleFaqModal: () => void;
};
